import axios from 'axios'
let route = process.env.VUE_APP_API_ROUTE + '/acc_account'

const findByCode = async function(code) {
    try {
        let response = await axios.get(route + '?filter[code_exact]=' + code)
        return response.data
    } catch (error) {
        return error.response.data
    }
}

export default findByCode
